























import Vue from "vue";
import Component from "vue-class-component";
import ManageFeaturesDialog from "../dialogs/ManageFeaturesDialog.vue"


@Component({
  components: {
    ManageFeaturesDialog
  },
})
export default class AdminMenu extends Vue {}
